<template>
  <div class="card" :class="{'-has-error': this.errors.cantFetchActiveListValues}">
    <div class="header">
      <div class="description">
        <h2 class="title">
          Logs de Consulta
          <span class="errorMessage" v-if="this.errors.cantFetchActiveListValues">Erro</span>
        </h2>
      </div>

      <query-log-nav
        :loading="loading"
        :list-active="listActive"
        @change="listActive = $event"
      />
    </div>

    <div class="body -no-padding">
      <log-list
        :loading="loading"
        :columns="['Data', 'Quantidade']"
        :values="activeListValues"
        v-if="listActive === 'query-success'"
      />

      <log-list
        :loading="loading"
        :columns="['Data', 'Quantidade']"
        :values="activeListValues"
        v-if="listActive === 'query-error'"
      />

      <log-list
        :loading="loading"
        :columns="['Consulta', 'Quantidade']"
        :values="activeListValues"
        v-if="listActive === 'per-query'"
      />
    </div>
  </div>
</template>

<script>
import QueryLogNav from '@/metrics/components/period/query-log/QueryLogNav.vue';
import LogList from '@/metrics/components/period/query-log/LogList.vue';

export default {
  name: 'QueryLog',

  props: {
    period: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      loading: false,
      listActive: 'query-success',
      activeListValues: [],
      errors: {
        cantFetchActiveListValues: false,
      },
    };
  },

  methods: {
    /**
     * Fetch active list values.
     *
     * @returns {Promise<void>}
     */
    async fetchActiveListValues() {
      try {
        this.resetErrors();
        this.resetActiveListValues();
        this.loading = true;

        const { data } = await this.$http.get(`metrics/charts/query-log/${this.listActive}?period=${this.period}`);

        this.activeListValues = [...data];
      } catch (err) {
        this.errors.cantFetchActiveListValues = true;
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Ocorreu um erro',
          text: 'Não foi possível carregar os logs de consultas.',
        });
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset errors to initial value.
     */
    resetErrors() {
      this.errors.cantFetchActiveListValues = false;
    },

    /**
     * Reset active list values.
     */
    resetActiveListValues() {
      this.activeListValues = [];
    },
  },

  watch: {
    listActive() {
      this.fetchActiveListValues();
    },

    period() {
      this.fetchActiveListValues();
    },
  },

  mounted() {
    this.fetchActiveListValues();
  },

  components: {
    QueryLogNav,
    LogList,
  },
};
</script>

<style scoped>

</style>
